import { createStore, createEffect } from "effector";
import { getCustomUserAgent } from "../../../common/customUserAgent";
import { getUuidAndSession } from "../../../common/localStorage";

export interface INews {
  actualTo: string | null;
  created: string;
  houseId: number | null;
  id: number;
  notice: string;
  show: number;
  title: string;
  topPost: number;
  important: number;
  updated: string;
  url: string;
}

export interface IQueryNews {
  companyId: number;
  accountId: number;
}

export interface IQueryNewsResult {
  loaded: boolean;
  fail: boolean;
  failMsg: string;
  news: INews[];
}

export const $news = createStore<IQueryNewsResult>({
  loaded: false,
  fail: false,
  failMsg: "",
  news: [],
});

export const queryNews = createEffect<IQueryNews, IQueryNewsResult>();
export const queryNewsNoAcc = createEffect<number, IQueryNewsResult>();

$news.on(queryNews.doneData, (_, val) => val);
$news.on(queryNewsNoAcc.doneData, (_, val) => val);

queryNews.use(({ accountId, companyId }) =>
  fetch("https://izba.kras-abs.ru/api/v3/news/getNewsWeb", {
    method: "POST",
    body: JSON.stringify({
      ...getUuidAndSession(),
      // companyId: companyId + "",
      account_id: accountId + "",
    }),
    headers: {
      accept: "*/*",
      "content-type": "application/x-www-form-urlencoded; charset=UTF-8",
      "Custom-User-Agent": getCustomUserAgent(),
    },
  })
    .then((res) => res.json())
    .then((res) => {
      if (!("news" in res)) {
        let msg = JSON.stringify(res);
        if ("error" in res) msg = res.error;
        return getQueryNewsResObj(msg);
      }
      let news = res.news as INews[];
      return getQueryNewsResObj("", false, news);
    })
    .catch((err) => {
      return getQueryNewsResObj(err.message);
    })
);

queryNewsNoAcc.use((accountId) => {
  return fetch("https://izba.kras-abs.ru/api/v3/news/getNewsWeb", {
    method: "POST",
    body: JSON.stringify({
      account_id: accountId + "",
      ...getUuidAndSession(),
    }),
    headers: {
      accept: "*/*",
      "content-type": "application/x-www-form-urlencoded; charset=UTF-8",
      "Custom-User-Agent": getCustomUserAgent(),
    },
  })
    .then((res) => res.json())
    .then((res) => {
      if (!("news" in res)) {
        let msg = JSON.stringify(res);
        if ("title" in res) msg = res.title;
        return getQueryNewsResObj(msg);
      }
      let news = res.news as INews[];
      return getQueryNewsResObj("", false, news);
    })
    .catch((err) => {
      return getQueryNewsResObj(err.message);
    })
}
);

function getQueryNewsResObj(
  failMsg: string = "",
  fail: boolean = true,
  news: INews[] = [] as INews[]
): IQueryNewsResult {
  return {
    loaded: true,
    fail: fail,
    failMsg: failMsg,
    news: news,
  } as IQueryNewsResult;
}

export function filterNews(
  news: INews[],
  all: boolean = false,
  important: boolean = false
): INews[] {
  return all
    ? news
    : important
      ? news.filter((item) => item.important === 1)
      : news.filter((item) => item.topPost === 1);
}
